import React from 'react';
import RadioButtonController from '@/components/radioButtonController';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
} from '@/bit/components/components.text';
import { DELIVERY } from '@/constants/operation';
import FormTemplate, { THEMES, TITLE_SIZE } from '@/components/formTemplate';

function Delivery({
  id,
  control,
  deliveryMethods,
  title,
  shippingText,
  simSelected,
  esimText,
  defaultDeliveryMethod,
  simDeliveryText,
}) {
  return (
    <div className="operation">
      <FormTemplate
        titleText={title}
        theme={THEMES.FULL}
        cyData="palanca"
        titleSize={title ? TITLE_SIZE.CAPTION1 : TITLE_SIZE.TITLE6}
      >
        {simSelected && (
          <div>
            <div className="choose-operation-container">
              <RadioButtonController
                inputName={`${id}.${DELIVERY.DELIVERY_METHOD.NAME}`}
                inputId={`${id}.${DELIVERY.DELIVERY_METHOD.ID}`}
                control={control}
                label={DELIVERY.DELIVERY_METHOD.LABEL}
                options={deliveryMethods}
                defaultValue={defaultDeliveryMethod}
              />
            </div>
            <div>
              <TextInfo
                text={simDeliveryText}
                color={TEXT_COLOR.GREY5}
                size={TEXT_SIZE.CAPTION1}
              />
            </div>
          </div>
        )}
        {!simSelected && (
          <div>
            <TextInfo
              text={shippingText}
              color={TEXT_COLOR.GREY5}
              size={TEXT_SIZE.CAPTION1}
            />
          </div>
        )}
        {esimText && (
          <div className="esim-card">
            <TextInfo
              text={esimText?.title}
              color={TEXT_COLOR.GREY6}
              size={TEXT_SIZE.TITLE6}
              fontType={TEXT_FONT_WEIGHT.BOLD}
            />
            <TextInfo
              className="esim-card-subtitle"
              text={esimText?.description}
              color={TEXT_COLOR.GREY5}
              size={TEXT_SIZE.CAPTION1}
            />
          </div>
        )}
      </FormTemplate>

      <style jsx>
        {`
          .operation {
            margin: 0px 0px 4px 0px;
          }
          .choose-operation-container {
            display: flex;
            direction: row;
            margin: 0px 0px 0px 0px;
            align-items: center;
          }
          :global(.choose-operation-container__input) {
            margin: 0px 0 8px 0px;
            width: 100%;
          }
          :global(.choose-operation-container__text) {
            margin: 0px 0 8px 0;
            position: relative;
          }
          :global(.choose-operation-container__text:last-child) {
            margin: 8px 0 0px 0;
            position: relative;
          }

          .esim-card {
            margin-top: 8px;
          }
          :global(.esim-card-subtitle) {
            margin-top: 8px;
          }
        `}
      </style>
    </div>
  );
}
export default Delivery;
